import { ChangeDetectionStrategy, Component, input } from "@angular/core";

// The one empty-state notice: an amber chip with a warning glyph. Used wherever
// a list, table or overlay comes back with nothing to show.
@Component({
  selector: "app-empty-message",
  templateUrl: "./empty-message.component.html",
  styleUrls: ["./empty-message.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyMessageComponent {
  public readonly text = input("No elements found");
}
